"use strict";
import { InterfaceEventName, NavBarSearchTypes } from "@uniswap/analytics-events";
import { OnchainItemSectionName } from "components/lists/OnchainItemList/types";
import { OnchainItemListOptionType } from "components/lists/items/types";
import { SearchResultType, extractDomain } from "features/search/SearchResult";
import { MobileEventName } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
import { isMobileApp } from "utilities/src/platform";
export function sendSearchOptionItemClickedAnalytics({
  item,
  section,
  rowIndex,
  searchFilters
}) {
  const searchContext = {
    ...searchFilters,
    category: section.sectionKey,
    isHistory: section.sectionKey === OnchainItemSectionName.RecentSearches,
    // history item click
    position: rowIndex,
    suggestionCount: section.data.length
    // suggestionCount is # of suggestions in this SECTION, not total # of suggestions
  };
  switch (item.type) {
    case OnchainItemListOptionType.Token: {
      const currency = item.currencyInfo.currency;
      if (isMobileApp) {
        sendAnalyticsEvent(MobileEventName.ExploreSearchResultClicked, {
          ...searchContext,
          name: currency.name ?? "",
          chain: currency.chainId,
          address: currency.isNative ? "NATIVE" : currency.address,
          type: "token"
        });
      } else {
        sendAnalyticsEvent(InterfaceEventName.NAVBAR_RESULT_SELECTED, {
          ...searchContext,
          chainId: currency.chainId,
          suggestion_type: searchContext?.isHistory ? NavBarSearchTypes.RECENT_SEARCH : searchContext?.query && searchContext?.query.length > 0 ? NavBarSearchTypes.TOKEN_SUGGESTION : NavBarSearchTypes.TOKEN_TRENDING,
          total_suggestions: searchContext?.suggestionCount,
          query_text: searchContext?.query ?? "",
          selected_search_result_name: currency.name ?? "",
          selected_search_result_address: currency.isNative ? "NATIVE" : currency.address
        });
      }
      return;
    }
    case OnchainItemListOptionType.WalletByAddress:
      sendAnalyticsEvent(MobileEventName.ExploreSearchResultClicked, {
        ...searchContext,
        address: item.address,
        type: "address"
      });
      return;
    case OnchainItemListOptionType.ENSAddress:
      sendAnalyticsEvent(MobileEventName.ExploreSearchResultClicked, {
        ...searchContext,
        name: item.ensName,
        address: item.address,
        type: "address",
        domain: extractDomain(item.ensName, SearchResultType.ENSAddress)
      });
      return;
    case OnchainItemListOptionType.Unitag: {
      sendAnalyticsEvent(MobileEventName.ExploreSearchResultClicked, {
        ...searchContext,
        name: item.unitag,
        address: item.address,
        type: "address",
        domain: extractDomain(item.unitag, SearchResultType.Unitag)
      });
      return;
    }
    case OnchainItemListOptionType.NFTCollection:
      sendAnalyticsEvent(MobileEventName.ExploreSearchResultClicked, {
        ...searchContext,
        name: item.name,
        chain: item.chainId,
        address: item.address,
        type: "collection"
      });
      return;
  }
}
